import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ListItemRendererComponent } from 'gung-list';
import { EdiIncomingDespatchAdvicesActionConfigService } from '../../../services/edi-incoming-despatch-advices-action-config/edi-incoming-despatch-advices-action-config.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
    selector: 'lib-edi-incoming-despatch-card-list',
    templateUrl: './edi-incoming-despatch-card-list.component.html',
    styleUrls: ['./edi-incoming-despatch-card-list.component.css'],
    standalone: false
})
export class EdiIncomingDespatchCardListComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  protected router = inject(Router);
  public ediNavigationService = inject(EdiNavigationService);

  ediNavigationBaseRoute: string;

  constructor(public actionConfigService: EdiIncomingDespatchAdvicesActionConfigService) {
    super();
  }

  ngOnInit(): void {
    this.ediNavigationBaseRoute = this.router.url.split('?')[0];
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  getIds(items: any[]): string[] {
    return items.map(i => i.id);
  }
}
